/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Ivory_Heron_HoldInputs */

const en_free_ivory_heron_hold = /** @type {(inputs: Free_Ivory_Heron_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Always uses the AI language model for classification instead of fast embedding matching. More accurate but slower. Use for nuanced or context-dependent topics.`)
};

const de_free_ivory_heron_hold = /** @type {(inputs: Free_Ivory_Heron_HoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwendet immer das KI-Sprachmodell zur Klassifizierung statt schnellem Embedding-Matching. Genauer, aber langsamer. Für nuancierte oder kontextabhängige Themen geeignet.`)
};

/**
* | output |
* | --- |
* | "Always uses the AI language model for classification instead of fast embedding matching. More accurate but slower. Use for nuanced or context-dependent topics." |
*
* @param {Free_Ivory_Heron_HoldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const free_ivory_heron_hold = /** @type {((inputs?: Free_Ivory_Heron_HoldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Ivory_Heron_HoldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_ivory_heron_hold(inputs)
	return de_free_ivory_heron_hold(inputs)
});